import { render, staticRenderFns } from "./go_top.vue?vue&type=template&id=3bf625b2&scoped=true&"
import script from "./go_top.vue?vue&type=script&lang=js&"
export * from "./go_top.vue?vue&type=script&lang=js&"
import style0 from "./go_top.vue?vue&type=style&index=0&id=3bf625b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf625b2",
  null
  
)

export default component.exports